<!-- ----------------------------------------------- -->
<template>
  <transition name="modal" appear>
    <div class="com-modal com-modal-overlay" :value="value" @click.self="closeModal">
      <v-col
        class="com-pc-card pa-0"
        style="width: 90%; height: 90%;"
        ref="ScamBox"
      >
        <v-row class="com-pc-card-header">
          <span class="com-pc-card-title">{{ text.title }}</span>
          <v-spacer></v-spacer>
          <v-btn small text icon color="white" @click="closeModal">
            <v-icon>highlight_off</v-icon>
          </v-btn>
        </v-row>
        <v-col class="com-pc-card-contents">
          <v-col class="tm-pc-graph-select-box pa-0">
            <v-row class="pa-1"> </v-row>
          </v-col>
          <v-col>
            <tm-Scam :height="height" :isDlg="true"></tm-Scam>
          </v-col>
        </v-col>
      </v-col>
    </div>
  </transition>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]簡易カメラダイアログ
 * TmScamDlg.vue
 * @author ILUKE
 */

import TmScam from "./TmScam.vue";

export default {
  name: "tm-Scam-dlg",
  components: {
    TmScam,
  },
  props: {
    value: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "簡易カメラ",
      },
      height: "600px",
    };
  },
  methods: {
    /**
     * モーダルが閉じたことを通知
     * 拡大画面を閉じた際に通常画面にダイアログがひらいたままにならないようにするため
     */ 
    closeModal() {
      this.$emit('input', false);
      this.$nextTick(() => {
        this.$emit('modal-close');
      })
    }
  }
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
